import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import Layout from '../Layout/index';
import Bottombar from '../Layout/bottombar/Bottombar';

import MainWrapper from './MainWrapper';

import LogIn from '../LogIn/index';
import FirstLogIn from '../FirstLogIn/index';
import UsersContainer from '../Users/index';
import EditUser from '../Users/Edit/index';
import StudentsContainer from '../Students/Index';
import StudentData from '../Students/StudentData';
import StudentsDashboard from '../Students/Dashboard';
import EditStudent from '../Students/Edit/index';
import InscriptionForm from '../StudentSubjects/InscriptionForm/index';
import StudentSubjects from '../StudentSubjects';
import SubjectInscription from '../StudentSubjects/Inscription';
import ExamsContainer from '../Exams';
import MyExamsContainer from '../Exams/StudentExams';
import StudentExamInscription from '../Exams/StudentExamInscription';
import StudentExamReviewRequests from '../Exams/StudentExamReviewRequests';

import ExamInscription from '../Exams/ExamForm/InscripcionExamen';
import ExamAddInscription from '../Exams/ExamForm/InscripcionExamen/AddIndex';

import ExamForm from '../Exams/ExamForm';
import ExamReviewRequestsIndex from '../Exams/ExamForm/ReviewRequestsIndex';
import MoveExamInscriptions from '../Exams/ExamForm/MoveExamInscriptionsIndex';
import ShowFinalReport from '../Exams/ExamForm/ShowFinalReport';
import ShowRecuperatorioReport from '../Exams/ExamForm/ShowRecuperatorioReport';
import ShowAllReport from '../Exams/ExamForm/ShowAllReport';
import ExamplePageOne from '../Example/index';
import ExamplePageTwo from '../ExampleTwo/index';

import MateriasPeriodo from '../MateriasPeriodo';
import MateriaPeriodoForm from '../MateriasPeriodo/EditForm';

import ProfesorDashboard from '../Profesor/Dashboard';
import ProfesorSubjects from '../Profesor/index';

import AlumnosMateriaProfesor from '../Profesor/ProfessorData';
import ReporteInscripcion from '../ReporteInscripcion';
import ReporteAlumnosPorMaterias from '../ReporteAlumnosPorMateria';
import ReporteAlumnos from '../ReporteAlumnos';
import ReporteAcademicStatus from '../ReporteAlumnos/AcademicStatus/index';

import PeriodoContainer from '../Periodos';
import PeriodoForm from '../Periodos/PeriodoForm';
import PeriodoEditarMaterias from '../Periodos/PeriodoForm/EditarMaterias';
import PeriodoEditarMateria from '../Periodos/PeriodoForm/MateriaPeriodo';
import MoveSection from '../Periodos/PeriodoForm/MateriaPeriodo/MoveSectionIndex';

import MallaContainer from '../Mallas';
import MallaForm from '../Mallas/MallaForm';
import SubjectsContainer from '../Subjects';
import SubjectForm from '../Subjects/SubjectForm';

import AuditLogContainer from '../AuditLog';

import ReporteProfesorRegistroContenido from '../Reportes/Profesor/RegistroContenido/index';

import { getCurrentUser } from '../../helpers/storage';

const getUrlId = (props) => {
  const { match: { params: { id } } } = props;
  return id;
};
const getUrlIdDetail = (props) => {
  const { match: { params: { idDetail } } } = props;
  return idDetail;
};

// Helper function to get URL parameters
const getUrlParams = (search) => {
  const params = new URLSearchParams(search);
  return {
    token: params.get('token'),
    email: params.get('email'),
  };
};

// Component to handle reset password validation and redirect or show login
const LoginHandler = ({ location, history, ...otherProps }) => {
  const { token, email } = getUrlParams(location.search);

  // If no token/email parameters, show normal login
  if (!token || !email) {
    return <LogIn {...otherProps} location={location} history={history} />;
  }

  // If token and email are present, validate and redirect
  React.useEffect(() => {
    // Make API call to validate token
    fetch(`/api/Usuarios/ResetPassword?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then((data) => {
        if (data.success === true) {
          // Token is valid, redirect to first_log_in with parameters
          history.push(`/first_log_in?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`);
        } else {
          // Token is invalid, redirect to login with error
          history.push('/log_in?error=invalid_token');
        }
      })
      .catch((error) => {
        console.error('Error validating reset token:', error);
        // On error, redirect to login
        history.push('/log_in?error=validation_error');
      });
  }, [token, email, history]);

  // Show loading while validating
  return (
    <div className="account">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">Validando token...</h3>
          </div>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p>Por favor espera mientras validamos tu enlace de recuperaci�n.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

LoginHandler.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const Pages = () => (
  <Switch>
    <Route exact path="/pages/users" component={UsersContainer} />
    <Route exact path="/pages/users/new" render={props => <EditUser {...props} id="" />} />
    <Route exact path="/pages/users/edit/:id" render={props => <EditUser {...props} id={getUrlId(props)} />} />
    <Route
      exact
      path="/pages/account/my-profile"
      render={
        props => <EditUser {...props} id={getCurrentUser().id} showProfile />
      }
    />
    <Route
      exact
      path="/pages/account/edit-profile"
      render={
        props => <EditUser {...props} id={getCurrentUser().id} showProfile editProfile />
      }
    />
    <Route exact path="/pages/students" component={StudentsContainer} />
    <Route exact path="/pages/students/new" render={props => <EditStudent {...props} id="" />} />
    <Route exact path="/pages/students/edit/:id" render={props => <EditStudent {...props} id={getUrlId(props)} />} />

    <Route exact path="/pages/student-subjects" component={StudentSubjects} />
    <Route
      exact
      path="/pages/student-subjects/:id"
      render={props => <StudentData {...props} id={getUrlId(props)} />}
    />
    <Route
      exact
      path="/pages/student-subjects/inscription/form"
      render={props => <InscriptionForm {...props} id="" />}
    />
    <Route
      exact
      path="/pages/student-subjects/inscription/new"
      render={props => <SubjectInscription {...props} id="" />}
    />
    <Route exact path="/pages/student-dashboard" component={StudentsDashboard} />

    <Route exact path="/pages/student-exams/inscription" component={StudentExamInscription} />
    <Route exact path="/pages/student-exams/review-requests" component={StudentExamReviewRequests} />
    <Route exact path="/pages/student-exams" component={MyExamsContainer} />
    <Route
      exact
      path="/pages/exams/inscription/:id"
      render={props => <ExamAddInscription {...props} idExamen={getUrlId(props)} />}
    />
    <Route
      exact
      path="/pages/exams/inscription/:id/:idDetail"
      render={
        props => <ExamInscription {...props} idExamen={getUrlId(props)} id={getUrlIdDetail(props)} />
      }
    />

    <Route exact path="/pages/exams" component={ExamsContainer} />
    <Route exact path="/pages/exams/new" render={props => <ExamForm {...props} id="" />} />
    <Route exact path="/pages/exams/edit/:id" render={props => <ExamForm {...props} id={getUrlId(props)} />} />
    <Route
      exact
      path="/pages/exams/edit/:id/review-requests"
      render={props => <ExamReviewRequestsIndex {...props} id={getUrlId(props)} />}
    />
    <Route
      exact
      path="/pages/exams/edit/:id/move-inscriptions"
      render={props => <MoveExamInscriptions {...props} id={getUrlId(props)} />}
    />

    <Route
      exact
      path="/pages/exams/show-final-report/:id"
      render={props => <ShowFinalReport {...props} id={getUrlId(props)} />}
    />
    <Route
      exact
      path="/pages/exams/show-recuperatorio-report/:id"
      render={props => <ShowRecuperatorioReport {...props} id={getUrlId(props)} />}
    />

    <Route
      exact
      path="/pages/exams/show-all-report/:id"
      render={props => <ShowAllReport {...props} id={getUrlId(props)} />}
    />

    <Route
      exact
      path="/pages/student-subjects/edit/:id"
      render={props => <SubjectInscription {...props} id={getUrlId(props)} />}
    />
    <Route path="/pages/one" component={ExamplePageOne} />
    <Route path="/pages/two" component={ExamplePageTwo} />
    <Route exact path="/pages/subjects-periods" component={MateriasPeriodo} />
    <Route exact path="/pages/subjects-periods/new" render={props => <MateriaPeriodoForm {...props} id="" />} />
    <Route
      exact
      path="/pages/subjects-periods/edit/:id"
      render={props => <MateriaPeriodoForm {...props} id={getUrlId(props)} />}
    />
    <Route exact path="/pages/periodos" component={PeriodoContainer} />
    <Route exact path="/pages/periodos/new" render={props => <PeriodoForm {...props} id="" />} />
    <Route exact path="/pages/periodos/edit/:id" render={props => <PeriodoForm {...props} id={getUrlId(props)} />} />
    <Route
      exact
      path="/pages/periodos/subjects/edit/:id/:idDetail"
      render={
        props => <PeriodoEditarMateria {...props} id={getUrlIdDetail(props)} idPeriodo={getUrlId(props)} />
      }
    />
    <Route
      exact
      path="/pages/periodos/subjects/edit/:id/:idDetail/move-section"
      render={
        props => <MoveSection {...props} id={getUrlIdDetail(props)} idPeriodo={getUrlId(props)} />
      }
    />
    <Route
      exact
      path="/pages/periodos/edit/:id/materias"
      render={props => <PeriodoEditarMaterias {...props} id={getUrlId(props)} />}
    />

    <Route exact path="/pages/mallas" component={MallaContainer} />
    <Route exact path="/pages/mallas/new" render={props => <MallaForm {...props} id="" />} />
    <Route exact path="/pages/mallas/edit/:id" render={props => <MallaForm {...props} id={getUrlId(props)} />} />

    <Route exact path="/pages/subjects" component={SubjectsContainer} />
    <Route
      exact
      path="/pages/subjects/edit/:id"
      render={props => <SubjectForm {...props} id={getUrlId(props)} />}
    />
    { /* <Route */}
    { /*  exact */}
    { /*  path="/pages/mallas/subjects/edit/:id/:idDetail" */}
    { /*  render={ */}
    { /*    props => <MallaEditarMateria {...props} id={getUrlIdDetail(props)} materiaMallaId={getUrlId(props)} /> */}
    { /*  } */}
    { /* /> */}

    <Route exact path="/pages/profesor-dashboard" component={ProfesorDashboard} />
    <Route exact path="/pages/profesor-subjects" component={ProfesorSubjects} />
    <Route
      exact
      path="/pages/profesor-subjects/:id"
      render={props => <AlumnosMateriaProfesor id={getUrlId(props)} />}
    />
    <Route exact path="/pages/reporte-inscripcion" component={ReporteInscripcion} />
    <Route exact path="/pages/reporte-alumnos" component={ReporteAlumnos} />
    <Route
      exact
      path="/pages/reporte-alumnos/academic-status/:id"
      render={props => <ReporteAcademicStatus {...props} id={getUrlId(props)} />}
    />
    <Route
      exact
      path="/pages/reporte-alumnos/academic-status"
      render={props => <ReporteAcademicStatus {...props} />}
    />
    <Route exact path="/pages/reporte-alumnos-por-materias" component={ReporteAlumnosPorMaterias} />
    <Route exact path="/pages/audit_log" component={AuditLogContainer} />
    <Route
      exact
      path="/pages/content-record"
      component={ReporteProfesorRegistroContenido}
    />
  </Switch>
);

const wrappedRoutes = props => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/pages" component={Pages} />
    </div>
    <Bottombar {...props} />
  </div>
);


const Router = props => (
  <MainWrapper {...props}>
    <main>
      <Switch {...props}>
        <Route exact path="/" render={innerProps => <LogIn {...innerProps} />} />
        <Route exact path="/log_in" render={innerProps => <LoginHandler {...innerProps} />} />
        <Route exact path="/first_log_in" render={innerProps => <FirstLogIn {...innerProps} />} />
        <Route {...props} path="/" component={wrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);
export default Router;
